<nav 
  appGsapReveal
  class="bg-white/80 backdrop-blur-xl border-gray-100 border-b shadow-2xl shadow-gray-200/30 w-full h-20 sticky top-0 z-[60] flex items-center"
>
	<div
		class="max-w-screen-2xl w-full flex flex-wrap sm:flex-row items-center mx-auto px-6 sm:px-8 justify-between"
	>
		<div class="flex flex-row space-x-4 items-center">
			<button
				*ngIf="canGoBack"
				(click)="goBack()"
				class="flex items-center text-gray-400 hover:text-[#10B981] font-black rounded-md p-2 bg-gray-50 hover:bg-emerald-50 transition-all duration-300"
			>
				<svg
					class="w-6 h-6"
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 14 10"
				>
					<path
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M13 5H1m0 0 4 4M1 5l4-4"
					/>
				</svg>
			</button>

            <div class="hover:scale-105 transition-transform duration-500">
                <app-logo />
            </div>
		</div>

		<div class="flex items-center md:order-2 space-x-4">
			<app-search class="hidden md:block" />
			<app-notifications [isDropdown]="true" class="hidden md:flex" />
			<app-profile-button />

			<button
                appRipple
				data-drawer-target="sidebar"
				data-drawer-toggle="sidebar"
				data-drawer-backdrop="false"
				aria-controls="sidebar"
				type="button"
				class="inline-flex items-center p-3 w-12 h-12 justify-center text-gray-500 rounded-md hover:bg-emerald-50 hover:text-[#10B981] transition-all duration-300 md:hidden"
			>
				<span class="sr-only">Open main menu</span>
				<svg
					class="w-6 h-6"
					aria-hidden="true"
					fill="currentColor"
					viewBox="0 0 20 20"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
						clip-rule="evenodd"
					></path>
				</svg>
			</button>
		</div>
	</div>
</nav>
